import http from "../../utils/http-common";

export async function downloadServiceProcedureFiles(
  procedureId: number
): Promise<Blob> {
  const response = await http.get(`/service_procedure/files/${procedureId}`, {
    responseType: "blob",
  });
  return response.data;
}
